// src/pages/ResetPassword.js
import React, { useState } from "react";
import { confirmPasswordReset } from "firebase/auth";
import { useSearchParams, useNavigate } from "react-router-dom";
import { auth } from "../services/firebase";
import { useAlert } from "./AlertContext";
import "./Login.css";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState("");
  const navigate = useNavigate();
  const showAlert = useAlert();
  const oobCode = searchParams.get("oobCode");

  // Password validation function
  const isStrongPassword = (password) => {
    return (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /[0-9]/.test(password) &&
      /[^A-Za-z0-9]/.test(password)
    );
  };

  const handleReset = async () => {
    if (!isStrongPassword(newPassword)) {
      showAlert(
        "Password must be at least 8 characters and include uppercase, lowercase, number, and special character.",
        "warning"
      );
      return;
    }
    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      showAlert("✅ Password updated! Redirecting...", "success");
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      showAlert("❌ Invalid or expired code.", "error");
    }
  };

  return (
    <div className="login-root" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '2vw' }}>
      <div className="login-left" style={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className="login-card" style={{ width: '100%', maxWidth: 400, margin: '2rem 0' }}>
          <div className="login-logo-row">
            <div className="login-logo">BAI</div>
            <span className="login-appname">BodhAI</span>
          </div>
          <h2 className="login-welcome">Reset Password</h2>
          <p className="login-subtext">Enter your new password below</p>
          <div className="login-input-group">
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={{ fontSize: '1rem' }}
            />
            <div style={{ color: '#b0c4d4', fontSize: '0.93rem', marginTop: '0.3rem' }}>
              Must be 8+ characters, include uppercase, lowercase, number, and special character.
            </div>
          </div>
          <button className="login-btn" style={{ marginTop: '1.2rem', fontSize: '1rem' }} onClick={handleReset}>Reset Password</button>
          <div className="login-bottom-row">
            <a href="/login" className="login-link">← Back to Login</a>
          </div>
        </div>
      </div>
      <div className="login-right" style={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className="login-showcase-card" style={{ minWidth: 260, maxWidth: 420, margin: '2rem 0', width: '100%' }}>
          <h2>Set a Strong Password</h2>
          <p>Choose a unique password to keep your BodhAI account secure.</p>
          <div className="login-stats-row" style={{ flexWrap: 'wrap', gap: '0.7rem' }}>
            <div className="login-stat">
              <div className="login-stat-value">8+</div>
              <div className="login-stat-label">Characters</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">A-Z</div>
              <div className="login-stat-label">Uppercase</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">a-z</div>
              <div className="login-stat-label">Lowercase</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">@#$</div>
              <div className="login-stat-label">Special Character</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">0-9</div>
              <div className="login-stat-label">Numbers</div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .login-root { flex-direction: column !important; padding: 1vw !important; }
          .login-left, .login-right { width: 100% !important; min-width: 0 !important; }
          .login-card, .login-showcase-card { margin: 1.2rem 0 !important; max-width: 98vw !important; }
        }
        @media (max-width: 600px) {
          .login-card, .login-showcase-card { padding: 1.2rem !important; }
          .login-logo-row { flex-direction: column; gap: 0.3rem; }
          .login-welcome { font-size: 1.3rem; }
        }
      `}</style>
    </div>
  );
};

export default ResetPassword;
